<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">

    <div class="page_header search-container">
      <span class="page_title">{{ $t('longOfflineStatistics.长期未联网') }}</span>
      <div style="flex:1;display: flex;    justify-content: flex-end;">
        <el-form :inline="true" size="small" :model="searchForm" class="search-form">
          <el-form-item :label="$t('statistics.fuelType')">
            <el-select v-model="searchForm.fuelType" style="width: 120px;">

              <el-option v-for="item in energyTypes" :key="item" :label="getEnergyName(item)" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('longOfflineStatistics.车牌号')">
            <el-input v-model="searchForm.CarNo" :placeholder="$t('longOfflineStatistics.enterCarNo')" clearable
              style="width: 160px;"></el-input>
          </el-form-item>
          <!--<el-form-item :label="$t('longOfflineStatistics.车号')">
            <el-input v-model="searchForm.CarCode" :placeholder="$t('longOfflineStatistics.enterCarCode')" clearable
              style="width: 140px;"></el-input>
          </el-form-item>-->
          <el-form-item :label="$t('longOfflineStatistics.终端编号')">
            <el-input v-model="searchForm.DeviceNo" :placeholder="$t('longOfflineStatistics.enterDeviceNo')" clearable
              style="width: 160px;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('longOfflineStatistics.车型')">
            <el-input v-model="searchForm.VehicleModel" :placeholder="$t('longOfflineStatistics.enterVehicleModel')"
              clearable style="width: 160px;"></el-input>
          </el-form-item>
          <el-form-item>
            <quickQuery :isDownload="true" @handleQuery="onQuery" @quickQuery="onQuery" @download="onExport"
              style="text-align: right" :timeShow="false" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-divider></el-divider>



    <!-- 数据表格 -->
    <div class="page_container">
      <el-table ref="offlineTable" :data="tableData" v-loading="loading" stripe style="width: 100%;"
        @sort-change="handleSortChange">

        <el-table-column prop="CarNo" align="center" :label="$t('longOfflineStatistics.车牌号')" min-width="120"
          sortable="custom"></el-table-column>
        <el-table-column prop="DeviceNo" align="center" :label="$t('longOfflineStatistics.终端编号')" min-width="100"
          sortable="custom">

        </el-table-column>
        <el-table-column prop="VehicleModel" align="center" :label="$t('longOfflineStatistics.车型')" min-width="160"
          sortable="custom"></el-table-column>
        <el-table-column prop="GpsDateTime" align="center" :label="$t('longOfflineStatistics.最后上线时间')" min-width="160"
          sortable="custom"></el-table-column>

        <el-table-column prop="Position" align="center" :label="$t('longOfflineStatistics.最后上线位置')" min-width="180"
          sortable="custom">
        </el-table-column>
        <el-table-column prop="OffLineDay" align="center" :label="$t('longOfflineStatistics.离线天数')" min-width="120"
          sortable="custom">
        </el-table-column>


      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo" @size-change="sizeChange">
      </kl-pagination>
    </div>


  </div>
</template>

<script>
import quickQuery from "../components/generalOrQuickQuery.vue";
import { queryLongStayRec } from '@/http/vehicle'
import language from '@/utils/getLanguageId';
import { mapState } from 'vuex'
export default {
  name: 'LongOfflineStatistics',
  components: {
    quickQuery
  },
  computed: {
    energyTypes() {
      // return [1, 2, 3, 4, 5, 6]
      return this.$store.getters.energyTypes;
    },
    LanguageId() {
      return language(this.$store.getters.locale)
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      searchForm: {
        CarNo: '',
        CarCode: '',
        DeviceNo: '',
        VehicleModel: '',
       fuelType: this.$store.getters.energyTypes[0],
      },
      sortInfo: {
        prop: '',
        order: ''
      },
      loading: false,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,

    }
  },
  mounted() {

  },
  methods: {
    getEnergyName(energyType) {
      if (energyType == 1) {
        return this.$t('oiltype.caiyouji');
      } else if (energyType == 2) {
        return this.$t('oiltype.qitiji');
      } else if (energyType == 3) {
        return this.$t('oiltype.youdain');
      } else if (energyType == 4) {
        return this.$t('oiltype.qidian');
      } else if (energyType == 5) {
        return this.$t('oiltype.chundiandong');
      } else if (energyType == 6) {
        return this.$t('oiltype.ranliao');
      }
      return '';
    },
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = val.beginDate;
      this.endDate = val.endDate;
      this.form.PageNo = 1;
      this.loadData();
    },
    handleSearch() {
      this.form.PageNo = 1;
      this.loadData();
    },
    handleSortChange({ prop, order }) {
      this.sortInfo.prop = prop;
      this.sortInfo.order = order;
      this.form.PageNo = 1;
      this.loadData();
    },
    resetSearch() {
      this.searchForm = {
        CarNo: '',
        CarCode: '',
        DeviceNo: '',
        VehicleModel: '',
        fuelType: this.$store.getters.energyTypes[0],
      };
      this.sortInfo = {
        prop: '',
        order: ''
      };
      if (this.$refs.offlineTable) {
        this.$refs.offlineTable.clearSort();
      }
      this.form.PageNo = 1;
      this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true

      // 实际项目中取消注释以下代码
      queryLongStayRec({
        "BegiBeginDatenTime": this.beginDate,
        "Language": this.LanguageId,
        "EndDate": this.endDate,
        "IsExport": isExport,
        "FuelType": parseInt(this.searchForm.fuelType),
        "PageNo": this.form.PageNo,
        "PageSize": this.form.PageSize,
        "CarNo": this.searchForm.CarNo,
        "ManufactureID": this.searchForm.CarCode,
        "DeviceNo": this.searchForm.DeviceNo,
        "VehicleModel": this.searchForm.VehicleModel,
        "SortField": this.sortInfo.prop,
        "SortOrder": this.sortInfo.order === 'ascending' ? 'ASC' : (this.sortInfo.order === 'descending' ? 'DESC' : '')
      }, isExport == 1 ? 'blob' : 'json').then(res => {
        this.loading = false
        if (isExport == 1) {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码

          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = this.$t('longOfflineStatistics.长期未联网') + "_" + this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx'; // 默认文件名

          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
        } else {

          this.tableData = res.data || []
          this.total = res.recordsTotal || 0

        }
      })



    },
    sizeChange(size) {
      this.form.PageSize = size;
      this.loadData();
    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
  }
}
</script>

<style scoped>
.search-container {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
</style>